import PersonaTelefonosView from "./PersonaTelefonosView";

export {PersonaTelefonosView}
export default PersonaTelefonosView
